exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-71a799da] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n}\n.modal-contents[data-v-71a799da] {\n  width: 356px;\n  text-align: left;\n}\n.modal-instruction[data-v-71a799da] {\n  font-size: 14px;\n  line-height: 130%;\n  color: #1b1e22;\n}\n.edit-form[data-v-71a799da] {\n  margin-top: 8px;\n}\n.vuetify-combo[data-v-71a799da],\n.form-control[data-v-71a799da] {\n  margin-bottom: 0;\n  margin-top: 18px;\n}\n", ""]);

// exports
